import { QueryConfig } from "store/utils/query-config";

export const remindersDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdTime"]
  }
};
